import { Card, Grid, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import success from '../Images/success1.png'
import successMsg from '../Images/paymentMsg.png'
import failed from '../Images/failed.png'
import failedMsg from '../Images/failedMsg.png'
import errorMsg from '../Images/400.png'
import error from '../Images/error.png'
import Header from './Header'
import Footer from './Footer'
import { getPaymentResponse } from '../../redux/actions/ComponentCallsActions'
import { EncKeys } from '../../../config'
import CryptoJS from 'crypto-js'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { DateUtilService } from '../../services/date-util-service'

const TransactionStatus = (props) => {
    const [recievedResponse, setRecievedResponse] = useState({
        Comments: '',
        Status: '',
        TransactionId: '',
        TrackId: '',
        Amount: '',
        TotalTransactionAmount: '',
        ChargesApplied: '',
        GST: '',
        PaymentGatewayType: '',
        PaymentMode: '',
        CardName: '',
        TransactionDate: '',
        Image: undefined,
        ImageTitle: undefined,
        textColor: 'black',
        PlatformFee: '',
    })
    let RedirectUrl = ''
    const loading = useSelector((state) => state.pageLoadingState)
    const paymentData = useSelector((state) => state.customerData)
    const dispatch = useDispatch()
    const location = useLocation()

    const key = CryptoJS.enc.Utf8.parse(EncKeys.VayanaEncKey)
    const iv = CryptoJS.enc.Utf8.parse(EncKeys.IV)

    const search = useLocation().search
    const id = new URLSearchParams(search).get('data')

    useEffect(() => {
        const interval = setInterval(() => {
            if (RedirectUrl !== '') {
                window.location.href = RedirectUrl
            }
        }, 5000)
        console.log('url id', id)
        console.log('track id', paymentData.customerData.PaymentRequest.TrackID)

        if (id !== undefined && id !== '' && id != null) {
            const gateway = localStorage.getItem('gateway')
            const cardNo = localStorage.getItem('encCardNo')
            let responseRequest = {
                PaymentOption: gateway === '' ? 'HDFCSeamless' : gateway,
                EncResp:
                    id == 0
                        ? paymentData.customerData.PaymentRequest.TrackID
                        : id,
                AgentId: paymentData.customerData.PaymentRequest.ClientId,
                OrderNumber: paymentData.customerData.PaymentRequest.OrderNo,
                CustomerPaymentRequestId:
                    paymentData.customerData.PaymentRequest.Id,
                EncCardNo: cardNo,
            }
            const jsonBody = JSON.stringify(responseRequest)

            let encryptedData = CryptoJS.AES.encrypt(
                CryptoJS.enc.Utf8.parse(jsonBody),
                key,
                {
                    keySize: 128 / 8,
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7,
                }
            )
            let postData = {
                payload: encryptedData.toString(),
            }

            localStorage.setItem('gateway', '')
            localStorage.setItem('encCardNo', '')

            dispatch(
                getPaymentResponse(
                    postData,
                    (res) => {
                        let temp = { ...recievedResponse }
                        if (res.statusCode === 200) {
                            const decryptedResponse = CryptoJS.AES.decrypt(
                                res.data,
                                key,
                                {
                                    keySize: 128 / 8,
                                    iv: iv,
                                    mode: CryptoJS.mode.CBC,
                                    padding: CryptoJS.pad.Pkcs7,
                                }
                            )
                            const decrypted = decryptedResponse.toString(
                                CryptoJS.enc.Utf8
                            )
                            let actualResponse = JSON.parse(decrypted)
                            temp.Status = actualResponse.Status
                            temp.Comments = actualResponse.Comments
                            temp.TransactionId = actualResponse.TransactionId
                            temp.TrackId = actualResponse.TrackId
                            temp.Amount = actualResponse.Amount
                            temp.TotalTransactionAmount =
                                actualResponse.TotalTransactionAmount
                            temp.ChargesApplied = actualResponse.ChargesApplied
                            temp.GST = actualResponse.GST
                            temp.PaymentGatewayType =
                                actualResponse.PaymentGatewayType
                            temp.PaymentMode = actualResponse.PaymentMode
                            temp.CardName = actualResponse.CardName
                            temp.TransactionDate =
                                actualResponse.TransactionDate
                            temp.PlatformFee = actualResponse.PlatformFee
                            RedirectUrl = actualResponse.RedirectUrl
                            if (
                                actualResponse.Status === 'Success' ||
                                actualResponse.Status === 'CAPTURED' ||
                                actualResponse.Status === 'SUCCESS'
                            ) {
                                temp.Image = success
                                temp.ImageTitle = successMsg
                                temp.textColor = 'green'
                            } else {
                                temp.Image = failed
                                temp.ImageTitle = failedMsg
                                temp.textColor = 'red'
                            }
                            setRecievedResponse(temp)
                        } else {
                            temp.Status = 'Transaction declined'
                            temp.Comments =
                                'Please Contact Vayana Team for further details'
                            RedirectUrl =
                                paymentData.customerData.PaymentRequest
                                    .RedirectUrl
                            temp.Image = error
                            temp.ImageTitle = errorMsg
                            temp.textColor = 'red'
                            setRecievedResponse(temp)
                        }
                    },
                    (err) => {
                        let temp = { ...recievedResponse }
                        temp.Status = 'Transaction declined'
                        temp.Comments =
                            'Please Contact Vayana Team for further details'
                        RedirectUrl =
                            paymentData.customerData.PaymentRequest.RedirectUrl
                        temp.Image = error
                        temp.ImageTitle = errorMsg
                        temp.textColor = 'red'
                        setRecievedResponse(temp)
                    }
                )
            )
        } else {
            let temp = { ...recievedResponse }
            temp.Status = location.state.Status
            temp.Comments = location.state.Comments
            temp.TransactionId = location.state.TransactionId
            temp.TrackId = location.state.TrackId
            temp.Amount = location.state.Amount
            temp.TransactionDate = location.state.TransactionDate
            RedirectUrl = location.state.RedirectUrl
            if (
                location.state.Status === 'Success' ||
                location.state.Status === 'CAPTURED'
            ) {
                temp.Image = success
                temp.ImageTitle = successMsg
                temp.textColor = 'green'
            } else {
                temp.Image = failed
                temp.ImageTitle = failedMsg
                temp.textColor = 'red'
            }
            setRecievedResponse(temp)
        }

        return () => clearInterval(interval)
    }, [])

    return (
        <>
            <Header />
            <div
                className="m-sm-30 transactionBody"
                style={{ paddingTop: '50px', paddingBottom: '100px' }}
            >
                <Grid pt={6} container spacing={0}>
                    <Grid item xs={0} md={2}></Grid>
                    <Grid item xs={12} md={8}>
                        <Card
                            className="px-6 pt-2 pb-4"
                            style={{ backgroundColor: 'white', margin: 10 }}
                        >
                            <div
                                style={{
                                    backgroundColor: '#2177F9',
                                    padding: '10px',
                                    color: 'white',
                                }}
                            >
                                <Typography>TRANSACTION STATUS</Typography>
                            </div>
                            <Grid
                                container
                                spacing={2}
                                style={{ padding: '20px' }}
                            >
                                <Grid item xs={12} md={4}>
                                    {loading.isLoading === true ? (
                                        <>
                                            <Skeleton height={160} count={1} />
                                        </>
                                    ) : (
                                        <>
                                            <div>
                                                <center>
                                                    <img
                                                        style={{
                                                            margin: '10px',
                                                            width: '80px',
                                                        }}
                                                        src={
                                                            recievedResponse.Image
                                                        }
                                                    />
                                                    <br />
                                                    <img
                                                        style={{
                                                            margin: '10px',
                                                            width: '180px',
                                                        }}
                                                        src={
                                                            recievedResponse.ImageTitle
                                                        }
                                                    />
                                                </center>
                                            </div>
                                        </>
                                    )}
                                </Grid>
                                <Grid item xs={12} md={7}>
                                    {loading.isLoading === true ? (
                                        <>
                                            <Skeleton
                                                style={{ marginBottom: '10px' }}
                                                height={18}
                                                count={6}
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <Grid container spacing={0}>
                                                <Grid item xs={5}>
                                                    <Typography
                                                        style={{
                                                            fontSize: '14px',
                                                            padding: '10px',
                                                        }}
                                                    >
                                                        Transaction Status:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <Typography
                                                        style={{
                                                            fontSize: '14px',
                                                            padding: '10px',
                                                            color: recievedResponse.textColor,
                                                        }}
                                                    >
                                                        {
                                                            recievedResponse.Status
                                                        }
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Typography
                                                        style={{
                                                            fontSize: '14px',
                                                            padding: '10px',
                                                        }}
                                                    >
                                                        Remarks:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <Typography
                                                        style={{
                                                            fontSize: '14px',
                                                            padding: '10px',
                                                            color: recievedResponse.textColor,
                                                        }}
                                                    >
                                                        {
                                                            recievedResponse.Comments
                                                        }
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Typography
                                                        style={{
                                                            fontSize: '14px',
                                                            padding: '10px',
                                                        }}
                                                    >
                                                        Transaction ID:
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={7}>
                                                    <Typography
                                                        style={{
                                                            fontSize: '14px',
                                                            padding: '10px',
                                                            color: recievedResponse.textColor,
                                                        }}
                                                    >
                                                        {
                                                            recievedResponse.TransactionId
                                                        }
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Typography
                                                        style={{
                                                            fontSize: '14px',
                                                            padding: '10px',
                                                        }}
                                                    >
                                                        TrackId:
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={7}>
                                                    <Typography
                                                        style={{
                                                            fontSize: '14px',
                                                            padding: '10px',
                                                            color: recievedResponse.textColor,
                                                        }}
                                                    >
                                                        {
                                                            recievedResponse.TrackId
                                                        }
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Typography
                                                        style={{
                                                            fontSize: '14px',
                                                            padding: '10px',
                                                        }}
                                                    >
                                                        Payment Amount:
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={7}>
                                                    <Typography
                                                        style={{
                                                            fontSize: '14px',
                                                            padding: '10px',
                                                            color: recievedResponse.textColor,
                                                        }}
                                                    >
                                                        {DateUtilService.formatToCurrency(
                                                            recievedResponse.Amount
                                                        )}
                                                    </Typography>
                                                </Grid>

                                                {/* Convenience Fee */}
                                                {Number(
                                                    recievedResponse?.ChargesApplied
                                                ) > 0 && (
                                                    <>
                                                        <Grid item xs={5}>
                                                            <Typography
                                                                style={{
                                                                    fontSize:
                                                                        '14px',
                                                                    padding:
                                                                        '10px',
                                                                }}
                                                            >
                                                                Convenience Fee:
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={7}>
                                                            <Typography
                                                                style={{
                                                                    fontSize:
                                                                        '14px',
                                                                    padding:
                                                                        '10px',
                                                                    color: recievedResponse.textColor,
                                                                }}
                                                            >
                                                                {DateUtilService.formatToCurrency(
                                                                    recievedResponse.ChargesApplied
                                                                )}
                                                            </Typography>
                                                        </Grid>
                                                    </>
                                                )}

                                                {/* Platform Fee */}
                                                {Number(
                                                    recievedResponse?.PlatformFee
                                                ) > 0 && (
                                                    <>
                                                        <Grid item xs={5}>
                                                            <Typography
                                                                style={{
                                                                    fontSize:
                                                                        '14px',
                                                                    padding:
                                                                        '10px',
                                                                }}
                                                            >
                                                                Platform Fee:
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={7}>
                                                            <Typography
                                                                style={{
                                                                    fontSize:
                                                                        '14px',
                                                                    padding:
                                                                        '10px',
                                                                    color: recievedResponse.textColor,
                                                                }}
                                                            >
                                                                {DateUtilService.formatToCurrency(
                                                                    recievedResponse.PlatformFee
                                                                )}
                                                            </Typography>
                                                        </Grid>
                                                    </>
                                                )}

                                                {/* GST */}
                                                {Number(recievedResponse?.GST) >
                                                    0 && (
                                                    <>
                                                        <Grid item xs={5}>
                                                            <Typography
                                                                style={{
                                                                    fontSize:
                                                                        '14px',
                                                                    padding:
                                                                        '10px',
                                                                }}
                                                            >
                                                                GST:
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={7}>
                                                            <Typography
                                                                style={{
                                                                    fontSize:
                                                                        '14px',
                                                                    padding:
                                                                        '10px',
                                                                    color: recievedResponse.textColor,
                                                                }}
                                                            >
                                                                {DateUtilService.formatToCurrency(
                                                                    recievedResponse.GST
                                                                )}
                                                            </Typography>
                                                        </Grid>
                                                    </>
                                                )}

                                                {/* Transaction Amount */}
                                                {Number(recievedResponse?.GST) >
                                                    0 && (
                                                    <>
                                                        <Grid item xs={5}>
                                                            <Typography
                                                                style={{
                                                                    fontSize:
                                                                        '14px',
                                                                    padding:
                                                                        '10px',
                                                                }}
                                                            >
                                                                Transaction
                                                                Amount:
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={7}>
                                                            <Typography
                                                                style={{
                                                                    fontSize:
                                                                        '14px',
                                                                    padding:
                                                                        '10px',
                                                                    color: recievedResponse.textColor,
                                                                }}
                                                            >
                                                                {DateUtilService.formatToCurrency(
                                                                    recievedResponse.TotalTransactionAmount
                                                                )}
                                                            </Typography>
                                                        </Grid>
                                                    </>
                                                )}

                                                <Grid item xs={5}>
                                                    <Typography
                                                        style={{
                                                            fontSize: '14px',
                                                            padding: '10px',
                                                        }}
                                                    >
                                                        Transaction Date:
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={7}>
                                                    <Typography
                                                        style={{
                                                            fontSize: '14px',
                                                            padding: '10px',
                                                            color: recievedResponse.textColor,
                                                        }}
                                                    >
                                                        {DateUtilService.toDisplayTime(
                                                            recievedResponse.TransactionDate
                                                        )}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <div
                                    style={{
                                        padding: '10px',
                                        marginBottom: '20px',
                                    }}
                                >
                                    <center>
                                        <Typography
                                            style={{
                                                fontSize: '20px',
                                                color: '#175aa9',
                                            }}
                                        >
                                            Please wait while you are redirected
                                            to the merchant site
                                        </Typography>
                                    </center>
                                </div>
                            </Grid>
                        </Card>
                    </Grid>
                    <Grid item xs={0} md={2}></Grid>
                </Grid>
            </div>
            <Footer />
        </>
    )
}

export default TransactionStatus
